module.exports = __webpack_public_path__ + "img/retake_the_quiz.50ac5da9.svg";